import React from "react";
import "./AdminAccess.css";

const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Admin Dashboard</h1>
      <div className="dashboard-grid">
        <div className="card">
          <h3>Add Employee</h3>
          <p>Add new employees to the system.</p>
          <button>Add Employee</button>
        </div>
        <div className="card">
          <h3>Remove Employee</h3>
          <p>Remove employees from the system.</p>
          <button>Remove Employee</button>
        </div>
        <div className="card">
          <h3>Update Employee</h3>
          <p>Update employee details.</p>
          <button>Update Employee</button>
        </div>
        <div className="card">
          <h3>Automated Alerts</h3>
          <p>View upcoming confirmations and appraisal deadlines.</p>
          <button>View Alerts</button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
